import React from 'react';
import { useCartContext } from '../Context/CartContext';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import toast from 'react-hot-toast';
import "../ItemCart/Itemcart.css";

const ItemCart = ({ item, moduloBebida }) => {
  const { removeProduct } = useCartContext();

  const drinkName = moduloBebida && item.selectedDrink ? item.selectedDrink.name : 'No seleccionado';
  const drinkPrice = moduloBebida && item.selectedDrink ? item.selectedDrink.precio : 0;
  const subtotal = item.quantity * (item.price + drinkPrice);

  const notify1 = () => {
    toast.dismiss();
    toast.error('Combo eliminado!', { duration: 3000 });
    removeProduct(item.id, item.selectedSize, item.acomp, item.selectedDrink, item.selectedDip);
  };

  return (
    <Container fluid className="p-1">
      <Card className="itemCart p-2 shadow-sm">
        <Row className="align-items-center">
          {/* 🖼️ Imagen del producto en un espacio más compacto */}
          <Col xs={3} className="text-center">
            <img src={item.image} alt={item.name} className="item-cart-img img-fluid rounded" />
          </Col>

          {/* 📋 Información del pedido en una columna más compacta */}
          <Col xs={6}>
            <h6 className="mb-1">{item.name}</h6>
            <p className="small">{item.quantity}x {item.selectedSize}</p>
            <p className="small"><b>Acomp:</b> {item.acomp}</p>
            <p><b>Salsa:</b> {item.selectedDip}</p>
            {moduloBebida && <p className="small"><b>Bebida:</b> {drinkName}</p>}

            {/* 🔥 Mostrar solo si hay anotaciones */}
            {item.anotaciones && item.anotaciones.trim() !== "" && (
              <p className="small"><b>Nota:</b> {item.anotaciones}</p>
            )}

            {/* 🔥 Mostrar solo si hay carne extra */}
            {item.extras?.medallones > 0 && (
              <p className="small"><b>Extras:</b> {item.extras.medallones} carne</p>
            )}
          </Col>

          {/* 💰 Precio sin centavos y botón eliminar en una misma columna */}
          <Col xs={3} className="text-end">
            <p className="mb-1"><b>${Math.round(subtotal)}</b></p>
            <Button variant="danger" size="sm" onClick={notify1}>🗑</Button>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default ItemCart;
